import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import TrashIcon from '@atlaskit/icon/core/migration/delete--trash';
export var getTokenDeltaProps = function getTokenDeltaProps(token) {
  var decodedToken;
  try {
    decodedToken = JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    // why would this be the case
    return {
      tokenDecodeError: typeof error.message === 'string' ? error.message : undefined,
      localTimeDelta: undefined,
      tokenExpiryTime: undefined
    };
  }

  // In my testing, sometimes issued at was missing
  var startTimestamp = decodedToken.iat || decodedToken.nbf;
  var getLocalTimeDeltaMilliseconds = function getLocalTimeDeltaMilliseconds(startTimestamp) {
    return startTimestamp ? startTimestamp - Date.now() : undefined;
  };
  return {
    tokenDecodeError: undefined,
    localTimeDelta: getLocalTimeDeltaMilliseconds(startTimestamp * 1000),
    // @ts-ignore
    tokenExpiryTime: decodedToken.exp * 1000
  };
};
export var transformReadAttachmentsToken = function transformReadAttachmentsToken(readAttachmentsToken) {
  var getFirstTokenIfAvailable = function getFirstTokenIfAvailable(tokensWithFiles) {
    return tokensWithFiles.length > 0 ? tokensWithFiles[0].token : null;
  };
  var token = getFirstTokenIfAvailable(readAttachmentsToken.tokensWithFiles);
  var tokenProps = typeof token === 'string' ? getTokenDeltaProps(token) : {};
  return {
    clientId: readAttachmentsToken.clientId,
    serviceHost: readAttachmentsToken.endpointUrl,
    token: token,
    areTokenPermissionsUpToDate: true,
    tokenLifespanInMs: readAttachmentsToken.tokenLifespanInSeconds * 1000,
    tokenIssueTimestamp: Date.now() - 10000,
    // added 10s buffer to cover network calls
    collection: null,
    tokenDecodeError: tokenProps.tokenDecodeError,
    localTimeDelta: tokenProps.localTimeDelta,
    tokenExpiryTime: tokenProps.tokenExpiryTime
  };
};
export var transformUploadContext = function transformUploadContext(uploadToken) {
  return {
    clientId: uploadToken.clientId,
    serviceHost: uploadToken.endpointUrl,
    token: uploadToken.token,
    tokenLifespanInMs: uploadToken.tokenDurationInMins * 60 * 1000,
    collection: uploadToken.targetCollection,
    tokenIssueTimestamp: Date.now() - 10000 // added 10s buffer to cover network calls
  };
};
export var transformData = function transformData(_ref) {
  var readToken = _ref.readToken,
    uploadToken = _ref.uploadToken;
  return {
    viewContext: readToken ? transformReadAttachmentsToken(readToken) : null,
    uploadContext: uploadToken ? transformUploadContext(uploadToken) : null
  };
};
export var formatFilesWithEditActions = function formatFilesWithEditActions(files, mediaClientConfig, collection, removeFile) {
  var toBeUploadedFiles = [];
  files.forEach(function (file) {
    toBeUploadedFiles.push({
      identifier: {
        id: file.id,
        mediaItemType: 'file',
        collectionName: collection
      },
      info: _objectSpread({}, file),
      mediaClientConfig: mediaClientConfig,
      actions: [{
        handler: removeFile,
        icon: /*#__PURE__*/React.createElement(TrashIcon, {
          color: "currentColor",
          spacing: "spacious",
          label: "Delete"
        }),
        label: 'Delete'
      }]
    });
  });
  return toBeUploadedFiles;
};
export var formatFilesWithViewActions = function formatFilesWithViewActions(files, mediaClientConfig, collection) {
  var toBeUploadedFiles = [];
  files.forEach(function (file) {
    toBeUploadedFiles.push({
      identifier: {
        id: file.id,
        mediaItemType: 'file',
        collectionName: collection
      },
      info: _objectSpread({}, file),
      mediaClientConfig: mediaClientConfig,
      actions: []
    });
  });
  return toBeUploadedFiles;
};
export var sortFilesYoungestFirstOnLeft = function sortFilesYoungestFirstOnLeft(a, b) {
  return b.info.creationDate && a.info.creationDate ? b.info.creationDate - a.info.creationDate : 0;
};